import downloadAppCode from './download-app-code';
import getEventsConfig from './env/config-api-events';
import getDeployConfig from './env/config-api-jsonschema';
import getProductProfilesConfig from './env/config-api-profiles';
import createDeployment from './env/create-deployment';
import createEnv from './env/create-env';
import deleteDeployment from './env/delete-deployment';
import deleteEnv from './env/delete-env';
import getActivationLogs from './env/deployment-api-activation-logs';
import getActivations from './env/deployment-api-activations';
import getDeploymentLogs from './env/deployment-api-deployment-logs';
import getDeploymentLogsById from './env/deployment-api-deployment-logs-by-id';
import getDeployments from './env/deployment-api-deployments';
import getDeploymentStatus from './env/deployment-api-get-status';
import getInsights from './env/deployment-api-insights';
import getEnv from './env/get-env';
import getEnvList from './env/get-env-list';
import getOrgs from './get-orgs';
import getPublicEc from './get-public-ecapps';
import retractXrApp from './retract-xr-app';
import reviewXrApp from './review-xr-app';
import { appRegistrySetup, envSetup, settings } from './setup';
import updateConsent from './update-consent';

export default {
  getOrgs,
  reviewXrApp,
  retractXrApp,
  settings,
  envSetup,
  appRegistrySetup,
  updateConsent,
  getEnvList,
  getEnv,
  createEnv,
  getPublicEc,
  getDeployConfig,
  getEventsConfig,
  getProductProfilesConfig,
  getDeploymentLogs,
  getDeployments,
  getActivations,
  getActivationLogs,
  getInsights,
  deleteEnv,
  deleteDeployment,
  createDeployment,
  getDeploymentLogsById,
  downloadAppCode,
  getDeploymentStatus,
};
